import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import styles from './HpRespLocationsModuleItem.scss';

const locationsTitleMap = {
    USA: 'United States',
};
function HpRespLocationsModuleItem({ item, showLocation, showLocationLink, onClick }) {
    const { title, isLinkable } = item;
    const locationTitle = showLocation ? locationsTitleMap[title] || title : '';

    return (
        <div className={`${styles.item} colXs12 colLg3`}>
            <div className={styles.image}>
                <a
                    href={showLocation ? item.link : ''}
                    rel={isLinkable ? null : 'nofollow'}
                    className={styles.link}
                    style={{ backgroundImage: `url(${item.imageUrl})` }}
                    onClick={onClick}
                >
                    <span className={styles.box}>
                        <div className={styles.title}>
                            {locationTitle}
                            {showLocationLink && (
                                <div className={styles.shopLocation}>
                                    <FormattedMessage
                                        id="homepage.modules.locations.shop"
                                        defaultMessage="Shop"
                                    />
                                </div>
                            )}
                        </div>
                    </span>
                </a>
            </div>
        </div>
    );
}

HpRespLocationsModuleItem.defaultProps = {
    showLocation: false,
    onClick: () => {},
};

HpRespLocationsModuleItem.propTypes = {
    showLocation: PropTypes.bool.isRequired,
    item: PropTypes.object,
    showLocationLink: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
};

export { HpRespLocationsModuleItem };
